import React, { useEffect, useState } from 'react';
import { Overlay, ModalImage, FadeScaleAnimation } from './styles';

type ImagePreviewModalProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  imageUrl: string;
  imageAlt?: string;
};

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  show,
  setShow,
  imageUrl,
  imageAlt = 'Imagem ampliada',
}) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      setScale(1);
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      setScale(prev => Math.min(prev + 0.1, 3));
    } else {
      setScale(prev => Math.max(prev - 0.1, 0.5));
    }
  };

  if (!show) return null;

  return (
    <>
      <Overlay onClick={() => setShow(false)} onWheel={handleWheel}>
        <ModalImage
          src={imageUrl}
          alt={imageAlt}
          onClick={e => e.stopPropagation()}
          style={{
            transform: `scale(${scale})`,
            transition: 'transform 0.2s ease',
            width: 'auto',
            height: 'auto',
            maxWidth: '90vw',
            maxHeight: '90vh',
            objectFit: 'contain',
            cursor: scale !== 1 ? 'move' : 'auto',
          }}
        />
      </Overlay>
      <FadeScaleAnimation />
    </>
  );
};

export default ImagePreviewModal;
